// PreCadastoDeInstrumentos.tsx

import React, { useEffect, useState } from "react";

import PageTitle from "components/PageTitle";
import Table from "components/TableComp";

import { Alert, Button, Card, Form, Modal, Toast } from "react-bootstrap";
import { ConfirmAlert } from "components";

import axios from "axios";

export interface IInstrumento {
  id: number;
  instrumento: string;
}

interface IColunaTabela {
  row: any;
  deleteFn?: (rowId: number | string) => Promise<void>;
  toggleOpcao?: (id: string) => void;
  editFn?: (id: number, instrumento: string) => void;
}

const ColunaDescricao = ({ value }: any) => {
  return <span>{value}</span>;
};

function ColunaAction({
  row,
  deleteFn,
  toggleOpcao,
  editFn,
}: IColunaTabela) {
  const handleEdit = () => {
    editFn?.(row.original.id, row.original.instrumento);
  };

  return (
    <div style={{ display: "flex", justifyContent: "end", gap: "8px" }}>
      <span
        className="action-icon"
        style={{ cursor: "pointer" }}
        onClick={(e) => {
          e.stopPropagation();
          handleEdit();
        }}
        title="Editar"
      >
        <i className="mdi mdi-square-edit-outline"/>
      </span>

      {toggleOpcao && (
        <span
          className="action-icon"
          style={{ cursor: "pointer" }}
          onClick={(e) => {
            e.stopPropagation();
            toggleOpcao(String(row.original.id));
          }}
          title="Gerenciar opções"
        >
          <i className="mdi mdi-format-list-checks"/>
        </span>
      )}

      <ConfirmAlert
        text={`Excluir o item "${row.original.instrumento}"?`}
        cb={() => deleteFn!(row.original.id)}
      >
        <span style={{ cursor: "pointer", margin : "2px" }} title="Excluir">
          <i className="mdi mdi-delete" />
        </span>
      </ConfirmAlert>
    </div>
  );
}
export const fetchInstrumentos = async () => {
  return await axios.get("/instrumento")
}
export default function PreCadastoDeInstrumentos() {
  const [loading, setLoading] = useState(false);

  const [reload, setReload] = useState<number>(0);

  const [instrumento, setInstrumento] = useState<string>("");

  const [modalCreate, setModalCreate] = useState(false);

  const [modalEdit, setModalEdit] = useState(false);

  const [editingId, setEditingId] = useState<number | null>(null);

  const [editingInstrumento, setEditingInstrumento] = useState<string>("");

  const [tableData, setTableData] = useState<IInstrumento[]>([]);

  const [toastMessage, setToastMessage] = useState<string>();

  const [toastType, setToastType] = useState<"success" | "error">("success");

  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    const getInstrumentos = async () => {
      try {
        setLoading(true);

        const response = await fetchInstrumentos();
        setTableData(response.data);
        setLoading(false);
      } catch (error) {
        console.error(error);
      }
    };

    getInstrumentos();
  }, [reload]);

  const deleteInstrumento = async (id: string | number) => {
    try {
      setLoading(true);

      await axios.delete(`/instrumento/${id}`);
      setToastMessage("Item deletado com sucesso!");
      setToastType("success");
      setShowToast(true);
      setReload((prev) => prev + 1);
    } catch (error) {
      setToastMessage("Falha ao deletar item");
      setToastType("error");
      setShowToast(true);
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const openEditModal = (id: number, instrumento: string) => {
    setEditingId(id);
    setEditingInstrumento(instrumento);
    setModalEdit(true);
  };

  const editInstrumento = async () => {
    try {
      if (!editingInstrumento.trim()) return;

      setLoading(true);

      await axios.put(`/instrumento/${editingId}`, {
        instrumento: editingInstrumento.trim(),
      });

      setEditingId(null);
      setEditingInstrumento("");

      setModalEdit(false);

      setReload((prev) => prev + 1);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const createInstrumento = async () => {
    try {
      if (!instrumento.trim()) return;

      setLoading(true);

      await axios.post("/instrumento", {
        instrumento: instrumento.trim(),
      });

      setToastMessage("Instrumento criado com sucesso!");
      setToastType("success");
      setShowToast(true);
      setInstrumento("");
      setModalCreate(false);
      setReload((prev) => prev + 1);
    } catch (error) {
      setToastMessage("Falha ao criar instrumento");
      setToastType("error");
      setShowToast(true);
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: "Relatório Parcial", path: "#" },
          {
            label: "Pré-cadastro de Instrumentos",
            path: "/relatorio-parcial",
            active: true,
          },
        ]}
        title="Pré-cadastro de Instrumentos"
      />

      <Card>
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="header-title mb-0">Instrumentos</h4>

            <Button
              variant="primary"
              onClick={() => {
                setModalCreate(true);
              }}
            >
              <i className="mdi mdi-plus-circle me-1" />
              Criar item
            </Button>
          </div>

          <p className="text-muted small">
            Gerencie os instrumentos disponíveis nas reavaliações.
          </p>

          {loading ? (
            <p className="text-muted">Carregando...</p>
          ) : (
            <Table
              columns={[
                {
                  Header: "Instrumento",
                  accessor: "instrumento",
                  Cell: ColunaDescricao,
                  sort: false,
                },
                {
                  Header: "",
                  accessor: "id",
                  Cell: ({ row }: any) => {
                    return (
                      <ColunaAction
                        row={row}
                        deleteFn={deleteInstrumento}
                        editFn={openEditModal}
                      />
                    );
                  },
                  sort: false,
                },
              ]}
              data={tableData}
              tableClass="table-striped"
              pagination={false}
            />
          )}
        </Card.Body>
      </Card>

      <div
        style={{
          position: "fixed",
          top: 20,
          right: 20,
          zIndex: 1050,
        }}
      >
        <Toast
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={2000}
          autohide
          bg={toastType === "success" ? "success" : "danger"}
        >
          <Toast.Body className="text-white">
            {toastMessage}
          </Toast.Body>
        </Toast>
      </div>

      <Modal
        show={modalEdit}
        onHide={() => {
          setModalEdit(false);
          setEditingId(null);
          setEditingInstrumento("");
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Editar Instrumento</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Instrumento</Form.Label>

              <Form.Control
                type="text"
                placeholder="Digite o nome do instrumento"
                value={editingInstrumento}
                onChange={(e) => setEditingInstrumento(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => {
              setModalEdit(false);
              setEditingId(null);
              setEditingInstrumento("");
            }}
          >
            Cancelar
          </Button>

          <Button
            variant="primary"
            onClick={() => {
              editInstrumento();
            }}
          >
            Salvar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={modalEdit}
        onHide={() => {
          setModalEdit(false);
          setEditingId(null);
          setEditingInstrumento("");
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Editar Instrumento</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Instrumento</Form.Label>

              <Form.Control
                type="text"
                placeholder="Digite o nome do instrumento"
                value={editingInstrumento}
                onChange={(e) => setEditingInstrumento(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => {
              setModalEdit(false);
              setEditingId(null);
              setEditingInstrumento("");
            }}
          >
            Cancelar
          </Button>

          <Button
            variant="primary"
            onClick={() => {
              editInstrumento();
            }}
          >
            Salvar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={modalCreate}
        onHide={() => {
          setModalCreate(false);
          setInstrumento("");
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Criar Instrumento</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Instrumento</Form.Label>

              <Form.Control
                type="text"
                placeholder="Digite o nome do instrumento"
                value={instrumento}
                onChange={(e) => setInstrumento(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => {
              setModalCreate(false);
              setInstrumento("");
            }}
          >
            Cancelar
          </Button>

          <Button
            variant="primary"
            onClick={() => {
              createInstrumento()}}
          >
            Salvar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}